module.exports = __webpack_public_path__ + "pnskfsquadron/img/tw-kr.jpg?34c1a768";